'use client';

import { Check } from 'lucide-react';
import { Step } from '../../../chat/types/base_step';
import { QuestionAnswers } from '../../../helpers/questions.helper';

interface OptionsSelectionProps {
  currentStep: Step;
  handleSubmit: (questionAnswers: QuestionAnswers[]) => void;
  answers: Record<string, any>;
}

export default function OptionsSelection({
  currentStep,
  handleSubmit,
  answers,
}: OptionsSelectionProps) {
  return currentStep.attributes.map(attribute => {
    const selectedOption = answers[attribute.name];
    return (
      <div className="space-y-4" key={attribute.name}>
        {attribute.options!.map(option => (
          <button
            style={{ WebkitTapHighlightColor: 'transparent' }}
            key={`${attribute.name}-${option.key}-${currentStep.name}`}
            onClick={e => {
              handleSubmit([
                { attributeName: attribute.name, value: option.value },
              ]);
              // Remove focus to avoid tap-highlight remaining
              (e.currentTarget as HTMLButtonElement).blur();
            }}
            className={`text-xs sm:text-sm w-full p-4 border rounded-md text-left active:bg-transparent active:border-emerald-600 transition-colors relative group ${
              selectedOption === option.value
                ? 'border-emerald-600 border-2'
                : ''
            }`}
          >
            {option.key}
            <span
              className={`absolute right-4 top-1/2 -translate-y-1/2 opacity-0 transition-opacity ${
                selectedOption === option.value ? 'opacity-100' : ''
              }`}
            >
              <Check className="h-5 w-5 text-emerald-600" />
            </span>
          </button>
        ))}
      </div>
    );
  });
}
